import { IGameModules } from 'core/rootInterfaces/root.interface';
import { classicModule as classic } from './ClassicGame';
// import { fastModule as fast } from './Fast';
import { towerModule as tower } from './TowerGame';
// import { fortuneWheelModule as wheel } from './FortuneWheel';
import { crashModule as crash } from './CrashGame';
// import { Module as baccarat } from './Baccarat';
import { caseModule as cases } from './CaseGame';
// import { craftModule as craft } from './CraftGame'
import { PoggiModule as poggi } from './Poggi';
import { caseBattle } from './CaseBattle';
const games: IGameModules = {
  cases,
  classic,
  caseBattle,
  // fast,
  crash,
  // wheel,
  tower,
  // baccarat,
  // craft,
  poggi,
};

export default games;

export const availableGameModules = Object.keys(games);
